import { render, staticRenderFns } from "./AbortionEvent.vue?vue&type=template&id=0bf33a90&scoped=true&"
import script from "./AbortionEvent.vue?vue&type=script&lang=js&"
export * from "./AbortionEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf33a90",
  null
  
)

export default component.exports